module.exports = __webpack_public_path__ + "h5/img/ewm_gzh.5c499bb8.jpg";